import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Field } from 'react-final-form';
import { Accordion, Select, Row, Col, KeyValue } from '@folio/stripes/components';

const ClearanceEditInfo = ({ accordionId, expanded, onToggle, libraries, initialValues, disabled }) => {
  const intl = useIntl();
  
  // Only show if user has clearance status
  if (initialValues?.customFields?.clearancestatus !== 'opt_0') {
    return null;
  }

  const getLibraryDisplayName = (library) => {
    const translationKey = `ui-tenant-settings.loclibs.name.${library.name}`;
    const translatedName = intl.formatMessage({ id: translationKey }, { defaultMessage: library.name });
    return translatedName;
  };

  const libraryOptions = libraries.map(lib => ({
    value: lib.id,
    label: getLibraryDisplayName(lib),
  }));

  return (
    <Accordion
      id={accordionId}
      label={<FormattedMessage id="ui-users.clearance.title" />}
      open={expanded}
      onToggle={onToggle}
    >
      <Row>
        <Col xs={4}>
          <KeyValue
            label={<FormattedMessage id="ui-users.clearance.title" />}
            value={<FormattedMessage id="ui-users.clearance.status.cleared" />}
          />
        </Col>
        <Col xs={4}>
          <KeyValue
            label={<FormattedMessage id="ui-users.clearance.date" />}
            value={initialValues?.customFields?.clearancedate || ''}
          />
        </Col>
        <Col xs={4}>
          <Field
            component={Select}
            name="customFields.clearancelibrary"
            label={<FormattedMessage id="ui-users.clearance.library" />}
            disabled={disabled}
          >
            <option value="">
              <FormattedMessage id="ui-users.clearance.library.select" />
            </option>
            {libraryOptions.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </Field>
        </Col>
      </Row>
    </Accordion>
  );
};

ClearanceEditInfo.propTypes = {
  accordionId: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  libraries: PropTypes.arrayOf(PropTypes.object),
  initialValues: PropTypes.object,
  disabled: PropTypes.bool,
};

ClearanceEditInfo.defaultProps = {
  libraries: [],
  initialValues: {},
  disabled: false,
};

export default ClearanceEditInfo;